import { render, staticRenderFns } from "./tweets.vue?vue&type=template&id=64bd190b&scoped=true&"
import script from "./tweets.vue?vue&type=script&lang=js&"
export * from "./tweets.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=64bd190b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd190b",
  null
  
)

export default component.exports